import Log from '../utils/Log';

// On définit un type qui regroupe tous les endroits où on peut poser le décorateur
type GenericContext =
  | ClassDecoratorContext
  | ClassMethodDecoratorContext
  | ClassGetterDecoratorContext
  | ClassSetterDecoratorContext
  | ClassFieldDecoratorContext
  | ClassAccessorDecoratorContext;

export function NonStd(reason?: string, fatal: boolean = false) {
  // On accepte 'any' pour la value (car ça peut être une classe, une fonction, undefined pour un champ...)
  // On utilise notre type GenericContext
  return function (value: any, context: GenericContext) {
    // On construit un message propre selon le type (classe, méthode, field...)
    const typeLabel =
      {
        class: 'La classe',
        method: 'La méthode',
        getter: 'Le getter',
        setter: 'Le setter',
        field: 'Le champ',
        accessor: 'L\'accesseur',
      }[context.kind] || 'L\'élément';

    const name = String(context.name);
    const message = `${typeLabel} '${name}' est non standard${reason ? ` : ${reason}` : ''}.`;

    // addInitializer fonctionne partout !
    // - Pour une classe : s'exécute à la définition de la classe.
    // - Pour un membre (méthode/champ) : s'exécute à la création de l'instance.
    context.addInitializer(function () {
      if (fatal) {
        throw new Error(message);
      } else {
        Log.warn(name, message);
      }
    });
  };
}
